import styled from "styled-components";

export const CrewStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const FormRow = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 100px;
`;

export const FormRow2 = styled.div`
  display: flex;
  /* justify-content: space-between; */
`;

interface ChoosePlanCardProps {
    isExpanded?: boolean;
  }

export const ConfirmButton = styled.button<ChoosePlanCardProps>`
    background-color: #FF5641;
    display: ${({ isExpanded }) => (isExpanded ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    width: 200px;
    padding: 10px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    bottom: -20px; 
    left: 78%;
`

export const ChoosePlanCard = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background-color: #ffffffcc;
    align-items: center;
    justify-content: center;
    padding: 50px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    transition: height 0.3s ease;
    margin-bottom: 200px;

    h1 {
        color: black;
        font-weight: 700;
        font-size: 15px;
        padding-left: 12px;
        margin-bottom: 10px;
        align-self: flex-end;
    }

    h2 {
    color: black;
    font-size: 20px;
    margin-top: 10px;
    }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  gap: 15px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 90px;

  select{
    height: 35px;
    border: 1px solid #ccc;
    border-radius: 60px;
    padding: 0 10px;
    font-size: 14px;
    outline: none;
    width: 103%;

    &:focus {
      border-color: #E0F1FF;
      border-width: 2px;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  }
`;

export const FormInput = styled.input`
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 60px;
  padding: 0 10px;
  font-size: 14px;
  outline: none;
  width: 100%;

  &:focus {
    border-color: #E0F1FF;
    border-width: 2px;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
    /* background-color: red; */

    h1{
        margin: -10px 9px;
        padding: 0;
        color: #FF5742;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-top: auto;
    }

    h3{
        color: #005CA9;
        font-size: 30px;
        margin-left: 9px;
        margin-top: 10px;
    }
`